import { get, writable } from "svelte/store";
import photos from "../stores/photos.js";
import locality from "../stores/locality.js";
import persisted from "../stores/common/persisted.js";
import windows from "../stores/windows.js";
import { report } from "../api/api.js";

const ONE_MINUTE_MS = 60 * 1000;

function createPhotoLocalityMonitor() {
	// Store last logged photo timestamp in localStorage
	const lastLogTimestamp = persisted("photoMonitor:lastLogTimestamp", true, writable(0));

	// Store the last printed photo URL
	const lastPrintedPhotoUrl = persisted("photoMonitor:lastPrintedPhotoUrl", true, writable(""));

	// Initialize the monitor
	function init(token) {
		if (!token) {
			console.error("Authentication token is required");
			return;
		}

		// Open "photos" and "talkie" windows when monitor starts
		if (!windows.isOpen("photos")) {
			windows.open("photos");
		}

		if (!windows.isOpen("talkie")) {
			windows.open("talkie");
		}

		// Subscribe to the photos store
		const unsubscribe = photos.subscribe((currentPhotos) => {
			if (currentPhotos.length === 0) {
				return;
			}

			const now = Date.now();
			const lastLogTime = get(lastLogTimestamp);

			// Check if enough time has passed since last log
			if (now - lastLogTime < ONE_MINUTE_MS) {
				return;
			}

			// Get the latest photo (last item in the array)
			const latestPhoto = currentPhotos[currentPhotos.length - 1];
			const previousPrintedUrl = get(lastPrintedPhotoUrl);

			// Only print if it's a new photo that wasn't printed in the previous run
			if (latestPhoto.url !== previousPrintedUrl) {
				// Get current locality
				const currentLocality = get(locality);

				if (!currentLocality) {
					return;
				}

				// Submit report to API
				report(currentLocality, latestPhoto.url, token).catch((error) => {
					console.error("Failed to report photo", error.message);
				});

				// Save the printed URL
				lastPrintedPhotoUrl.set(latestPhoto.url);
			}

			// Update last log timestamp
			lastLogTimestamp.set(now);
		});

		// Return function to stop monitoring
		return unsubscribe;
	}

	// Clear logged URLs (useful for testing)
	function reset() {
		lastPrintedPhotoUrl.set("");
		lastLogTimestamp.set(0);
	}

	return {
		init,
		reset
	};
}

window.monitor = createPhotoLocalityMonitor();
